import { useEffect, useMemo } from "react";
import { motion } from "framer-motion";

const POS = [-27, 27];

export const IntroLoader = ({ onFinish }) => {
  useEffect(() => {
    const t = setTimeout(onFinish, 2400);
    return () => clearTimeout(t);
  }, [onFinish]);

  const cubelets = useMemo(() => {
    const arr = [];
    let i = 0;
    for (const x of POS) for (const y of POS) for (const z of POS) {
      arr.push({
        x, y, z,
        sx: (Math.random() - 0.5) * 520,
        sy: (Math.random() - 0.5) * 520,
        sz: (Math.random() - 0.5) * 640,
        delay: 0.07 * i++,
      });
    }
    return arr;
  }, []);

  return (
    <motion.div
      data-testid="intro-loader"
      className="fixed inset-0 z-[200] bg-ink flex flex-col items-center justify-center hero-grid-bg"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="intro-scene">
        <div className="intro-cube">
          {cubelets.map((c, i) => (
            <div
              key={i}
              className="cubelet"
              style={{
                "--fx": `${c.x}px`,
                "--fy": `${c.y}px`,
                "--fz": `${c.z}px`,
                "--sx": `${c.sx}px`,
                "--sy": `${c.sy}px`,
                "--sz": `${c.sz}px`,
                animationDelay: `${c.delay}s`,
              }}
            >
              <span className="cf cf-f" />
              <span className="cf cf-b" />
              <span className="cf cf-r" />
              <span className="cf cf-l" />
              <span className="cf cf-t" />
              <span className="cf cf-d" />
            </div>
          ))}
        </div>
      </div>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.6 }}
        className="font-mono text-xs uppercase tracking-[0.4em] text-paper mt-20"
      >
        Klaus<span className="text-volt">·</span>Baumgart
      </motion.p>

      <div className="intro-bar mt-6">
        <div className="intro-bar-fill" />
      </div>
    </motion.div>
  );
};
